import { render } from "./DynamicLoading.vue?vue&type=template&id=4a1650c0"
import script from "./DynamicLoading.vue?vue&type=script&lang=js"
export * from "./DynamicLoading.vue?vue&type=script&lang=js"
script.render = render

export default script